export default [
  {
    path: '/skapa',
    redirectFrom: ['/create-if'],
  },
  {
    path: '/skapa/person',
    redirectFrom: ['/create-if/individual'],
  },
  {
    path: '/skapa/insamling',
    redirectFrom: ['/create-if/individual'],
  },
  {
    path: '/donera',
    redirectFrom: ['/donate'],
  },
  {
    path: '/donera/:id/tack',
    redirectFrom: ['/donate/:id/thank-you'],
  },
  {
    path: '/insamling/:id',
    redirectFrom: ['/individual-fundraiser/:id'],
  },
];
